var exports = {
  "k": "xa15a2ab7--034c99--container",
};

module.exports = exports;
